module.exports = __webpack_public_path__ + "img/text-documents_orange.94ff85a4.svg";